import React, { useState } from "react";
import {
  List,
  Datagrid,
  TextField,
  ShowButton,
  EditButton,
  FunctionField,
  ReferenceField,
  Filter,
  TextInput,
  ReferenceInput,
  SelectInput,
} from "react-admin";
import CopyButton from "../../components/CopyButton";
import ListPagination from "../../components/ListPagination";
import ConfirmDeleteButton from "../../components/ConfirmDeleteButton";
import ConfirmBulkActions from "../../components/ConfirmBulkActions";
import RenameTextField from "../../components/RenameTextField";
import zoneAlerts from "../../defaults/ZoneAlerts";
import { perPage } from "../../defaults/Defaults";
import useUser from "../../hooks/useUser";

const ZoneFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search by name" source="name" alwaysOn />
    <ReferenceInput
      perPage={1000000000000}
      fullWidth
      label="Choose Organization"
      source="OrganizationId"
      reference="organizations"
    >
      <SelectInput optionText="name" />
    </ReferenceInput>
  </Filter>
);

const ZoneList = (props) => {
  const user = useUser();

  let [gridKey, changeGridKey] = useState(Math.random());

  const updateDataGrid = () => changeGridKey(Math.random());
  const alertM = `Warning, this cannot be undone. This zone will be deleted permanently.`;
  return (
    <List
      key={gridKey}
      {...props}
      bulkActionButtons={<ConfirmBulkActions />}
      perPage={perPage}
      pagination={<ListPagination />}
      title="Zones"
      filters={<ZoneFilter />}
    >
      <Datagrid>
        {user.role === "super-admin" && (
          <CopyButton label="Alarm.com ID">
            <FunctionField
              label="Alarm.com ID"
              render={(record) => `#SOS#${record.id}`}
            />
          </CopyButton>
        )}
        <ReferenceField
          label="Organization"
          source="OrganizationId"
          reference="organizations"
          link="show"
        >
          <TextField source="name" />
        </ReferenceField>
        <TextField label="Zone Name" source="name" />
        <TextField label="ID" source="customID" />
        <RenameTextField
          label="Message Type"
          source="message_prefix"
          types={zoneAlerts}
          target="name"
        />
        <TextField label="Address Line 1" source="address_line_1" />
        <ShowButton />
        <EditButton />
        <ConfirmDeleteButton
          dataprovidersource={`zones`}
          alertmessage={alertM}
          update={updateDataGrid}
        />
      </Datagrid>
    </List>
  );
};

export default ZoneList;
